import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
import React, { forwardRef } from 'react';
import Text, { SYSTEM_PROPS as TEXT_SYSTEM_PROPS } from '../Text';
import system from '../../system';
var SYSTEM_PROPS = [].concat(TEXT_SYSTEM_PROPS, ['paddingProps', 'widthProps']); // Temporary backward compatibility

const Paragraph = /*#__PURE__*/function () {
  const Paragraph = /*#__PURE__*/forwardRef(function (props, ref) {
    // We extend the System of text, and also pass previous props -> system will not pass system-props
    var _system = system(props, SYSTEM_PROPS),
        className = _system[0],
        style = _system[1],
        rest = _system[2];

    return /*#__PURE__*/React.createElement(Text, _extends({
      className: className,
      ref: ref,
      style: style
    }, rest, {
      size: "Paragraph"
    }));
  });
  Paragraph.displayName = 'Paragraph';
  Paragraph.identifier = Paragraph.displayName;
  Paragraph.clonableProps = SYSTEM_PROPS;
  Paragraph.defaultProps = {
    as: 'p',
    decoration: 'none',
    fontFamily: 'system',
    textAlign: 'inherit'
  };
  return Paragraph;
}();

export default Paragraph;